module.exports = __webpack_public_path__ + "static/img/12.9c2b62f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting674/images/12.png
// module id = /Y2+
// module chunks = 4